import {Injectable} from "@angular/core";
import {ApiService} from "../../../../shared/services/api/api.service";
import {Observable} from "rxjs";
import {IPagination} from "../../../../shared/services/api/interface/pagination.interface";
import {IPatientCreate, IPatientUpdate} from "../interface/patient.interface";

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  constructor(private readonly apiService: ApiService) {
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`patient/patient-filter-list`, {event: event, filter: filter})
  }

  getPatientInfo(id: number): Observable<any> {
    return this.apiService.get(`patient/get-patient-info/${id}`);
  }

  /**
   * Hasta listesini getirir (Sayfalama ve Filtreleme ile)
   * @param filters Filtre parametreleri (tckn, name, gender vs.)
   * @param first Sayfa numarası (varsayılan 1)
   * @param rows Sayfa başına öğe sayısı (varsayılan 10)
   */
  getPatients(filters: any = {}, first: number = 1, rows: number = 10): Observable<any> {
    const parameters: { [key: string]: string } = {
      first: first.toString(),
      rows: rows.toString(),
      ...filters, // Dinamik olarak filtreleri ekler
    };
    const loaderConfig = { showLoader:true, message: 'Hasta listesi yükleniyor...' };

    return this.apiService.get('patient/get-patients',parameters,loaderConfig)
  }

  getById(id: string){
    return this.apiService.get(`patient/${id}`);
  }

  createPatient(patient: IPatientCreate){
    return this.apiService.post('patient/create', patient);
  }

  updatePatient(patient: IPatientUpdate){
    return this.apiService.patch('patient/update', patient);
  }

  deletePatient(id: number){
    return this.apiService.delete(`patient/delete/${id}`);
  }

  getSpecialCategoryTagLogSummary(patientId: number) {
    return this.apiService.get<Record<string, number>>(
      `patient/${patientId}/special-category-tags/log-summary`
    );
  }

  getSpecialCategoryTagLogs(patientId: number, tagUid: string) {
    return this.apiService.get<any[]>(
      `patient/${patientId}/special-category-tags/${encodeURIComponent(tagUid)}/logs`
    );
  }
}
